(() => {
  const productRoot =
    document.querySelector('product-info') ||
    document.querySelector('product-form') ||
    document.querySelector('[data-section-type="main-product"]') ||
    document.querySelector('.product') ||
    document.querySelector('main') ||
    document;

  if (!productRoot) return;


  const whenIdle = (fn, timeout = 2000) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout });
    } else {
      setTimeout(fn, 300);
    }
  };

  // ============================================================================
  // PDP FEATURES MODULE
  // ============================================================================
  /**
   * Handle PDP-specific features: accelerated checkout only
   */
  const PDPFeatures = {
    config: {
      productRoot,
      form: null,
      dynamicCheckout: null,
      acceleratedCheckoutEnabled: false,
    },

    selectors: {
      form: 'product-form, form[data-product-form], .product-form',
      variantSelects: 'variant-selects, [data-variant-selects]',
      dynamicCheckout: '[data-shopify="payment-button"], [data-dynamic-checkout], .dynamic-checkout__content',
      mainAtcButton: 'button[type="submit"][name="add"], button[type="submit"]',
    },

    /**
     * Main initialization
     */
    init() {
      this.log('PDPFeatures init starting');

      // Detect elements
      this.config.form = productRoot.querySelector(this.selectors.form);
      this.config.dynamicCheckout =
        productRoot.querySelector(this.selectors.dynamicCheckout) ||
        document.querySelector(this.selectors.dynamicCheckout);

      // Check accelerated checkout setting
      this.config.acceleratedCheckoutEnabled =
        window.SA_ACCELERATED_CHECKOUT_ENABLED === true || !!this.config.dynamicCheckout;

      // Initialize features only if toggle enabled AND DOM element exists
      if (this.config.acceleratedCheckoutEnabled) {
        this.initAcceleratedCheckout();
      }

      this.log('PDPFeatures init complete');

      // Dispatch event for other modules
      document.dispatchEvent(new CustomEvent('pdp:ready', {
        detail: {
          hasAcceleratedCheckout: this.config.acceleratedCheckoutEnabled,
          hasStickyATC: false,
        },
      }));
    },

    /**
     * Initialize accelerated checkout with lazy/intent-based loading
     */
    initAcceleratedCheckout() {
      if (!this.config.dynamicCheckout) {
        this.log('No dynamic checkout element found, skipping');
        return;
      }

      this.log('Accelerated checkout detected, setting up lazy init');

      // Track if we've already initialized
      if (this.config.dynamicCheckout.hasAttribute('data-ac-initialized')) {
        this.log('Accelerated checkout already initialized');
        return;
      }

      // Intent triggers: user interaction or idle
      const initializeACCheckout = () => {
        if (!this.config.dynamicCheckout.hasAttribute('data-ac-initialized')) {
          this.config.dynamicCheckout.setAttribute('data-ac-initialized', 'true');
          this.log('Initializing accelerated checkout on intent');

          // Trigger any Shopify-native init if present
          if (window.Shopify?.PaymentButton?.init) {
            window.Shopify.PaymentButton.init();
          }
        }
      };

      // Init on idle callback
      whenIdle(initializeACCheckout, 1000);

      // Also init on first user interaction (scroll, click, touch)
      const interactionHandler = () => {
        initializeACCheckout();
        document.removeEventListener('scroll', interactionHandler);
        document.removeEventListener('click', interactionHandler);
        document.removeEventListener('touchstart', interactionHandler);
      };

      document.addEventListener('scroll', interactionHandler, { once: true });
      document.addEventListener('click', interactionHandler, { once: true });
      document.addEventListener('touchstart', interactionHandler, { once: true });
    },
    /**
     * Dev-only logging
     */
    log(message) {
      if (window.devLog) {
        window.devLog('PDPFeatures', message);
      }
    },
  };

  function init() {
    document.documentElement.classList.add('sa-pdp-ready');

    // Initialize PDP-specific features
    PDPFeatures.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenIdle(init));
  } else {
    whenIdle(init);
  }
})();
